// Generated by scripts/build-releases.js from integrations-releases/published/*.md. Do not edit.
export const INTEGRATIONS_RELEASES = [
    {
        "id": "2026-10-19-1.3.0",
        "title": "State Data refresh now rescans every district",
        "version": "1.3.0",
        "date": "2026-10-19",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** The refresh button at the top of State Data now rescans every state and every district's enrolment and republishes the snapshot the page shows. Until now it re-read a snapshot nothing was updating, so the page had shown 22 September for weeks. In a state's panel, each enrolled district has its own refresh button: it re-copies the state's current outputs, registers anything missing, and the row says what changed (\"3 updated, 110 unchanged\")."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Implementations → State Data, beside \"snapshot …\", and beside each enrolled district in a state's panel."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing. A rescan takes a few minutes; the button spins and the page reloads when it finishes."
            },
            {
                "type": "p",
                "text": "**Good to know.** Clicking again during a rescan joins it. Unchanged files are skipped."
            }
        ]
    },
    {
        "id": "2026-10-18-1.2.0",
        "title": "Sync Staleness on one page, edit a dataset's sources in place, and state data enrolment that finishes",
        "version": "1.2.0",
        "date": "2026-10-18",
        "blocks": [
            {
                "type": "p",
                "text": "**Sync Staleness.** Sync Telemetry Tagging is now **Sync Staleness** (Implementations → Sync Staleness): clients on the left, sorted by what needs a look, each client's datasets grouped by data source, and a dataset's details beside the list: why it's flagged, what we saw each night, its sources and the tag form. The morning email's client links open the same page. Tabs became filters: Needs attention, New today, Fresh, All checked, Setup incomplete, Tagged. \"Can't tell\" is now **Unknown**, as in the email. Rows you tag, untag or set sources for are marked **Changed since this morning** until the 7:30 check judges them. **Acknowledge** a Stale, Tag disagrees or Unknown row with a note and an owner: it stays in the queue, labelled, and drops out of the email's New. Retired datasets have their own **To remove** list; history entries can be **restored**."
            },
            {
                "type": "p",
                "text": "**What the checker says, and what it doesn't.** A dataset is only called Stale or Fresh with real evidence: a verified lineage entry, a content change the fingerprint saw, or a file date with history behind it. Everything else reads **Unknown** with the reason. Tags do exactly what the tag form says, including expected-by dates with grace and yearly repeat. The **Resolved** tile covers the last 7 days and each row says why it left; a **No longer checked** list shows datasets that vanished from the run; a **Checker error** label marks datasets the checker failed on. For about five days after this release most \"unchanged since\" readings restart as Unknown while new stamps accumulate."
            },
            {
                "type": "p",
                "text": "**Edit where a dataset's data comes from.** In Sync Staleness, open a dataset and click **Edit sources**: pick from its config and its job's reads, or type to search storage. Dated files show as one entry. Save checks first, never keeps a broken entry, and applies at once; the next night's run verifies it. The **Lineage review** tile lists every dataset whose sources need a person, with Confirm, Edit and \"Confirm all drafts\" per client. Same form under Data Configuration → Datasets → **Sources**. Unknown now splits into *waiting on history* and *needs a person*; new tag **Paused (known off)**."
            },
            {
                "type": "p",
                "text": "**Setup ends with \"Sources set\".** Setting up a source has a **Sources set** step: complete once every dataset has a main source (lookups stay optional). Data Configuration → a source → **Sources** shows it as Done or Blocked; each main is filled in from its config, so you click **Confirm**. Sources set 8 or more days ago with no job building them say \"No job has built it\"."
            },
            {
                "type": "p",
                "text": "**State data enrolment finishes, on any state.** Implementations → **State Data** → **Enrol** works for Kentucky and Ohio. Copying a large state's files used to run inside the API and could crash it part-way: on 16 October, Adair was left with 17 of 113 datasets and nothing registered, yet listed as enrolled. Enrol now answers at once; the copy runs on its own with room for the largest files, and the row shows progress until the datasets are registered. Each enrolled district shows **registered / total**; a short one shows **Finish**, which copies what is missing and registers it. A state's panel opens in seconds and has a refresh button. Texas no longer fails with `'manual_uploads'` after copying. Enrolling also creates and links the source's **integration**, the same way **Add source** does, and it starts hidden until you turn on visibility in Data Configuration. The **Academic Year** column is flagged as the academic year."
            },
            {
                "type": "p",
                "text": "**What changes for you.** \"Not checked\" is now **Setup incomplete** everywhere. Drafted sources sit under Lineage review only. Otherwise nothing changes in how you work. The client copy line in Sync Staleness is report-only for now."
            }
        ]
    },
    {
        "id": "2026-10-13-1.1.0",
        "title": "Edit request updates, and confirm steps that don't freeze the tab",
        "version": "1.1.0",
        "date": "2026-10-13",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** In Implementations → Requests you can edit an update you posted. It shows \"edited\", and the earlier versions stay viewable. Each request can also name a **Client owner (district)**: the person at the district on it. Every \"Are you sure?\" step in Data Configuration now opens inside the page instead of the browser's pop-up, which could freeze the tab."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work. You can only edit your own updates; nothing is deleted, and client owners are never emailed."
            }
        ]
    },
    {
        "id": "2026-09-30-1.0.0",
        "title": "Delete a data source, safely and undoably",
        "version": "1.0.0",
        "date": "2026-09-30",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Delete a data source from Data Configuration. A review first shows everything it removes, which dashboards use it, and anything blocking it. Those dashboards can be made not public or unshared in the same step. One Undo puts it all back."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Data Configuration → a source → **Delete data source**. Undo is on the dialog, and later under the client's **History**."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Use this, not the old Webapp delete. Type the source name to confirm."
            },
            {
                "type": "p",
                "text": "**Good to know.** Files in storage are kept. If a sync is still writing to the source, the delete stops and asks you to review again. These notes now live behind the rat in the nav."
            }
        ]
    }
];
